import ConfirmModalUI from '@/components/common/ConfirmModalUI/ConfirmModalUI'
import { debounce } from 'lodash'
import { useConfigUI } from '../../context'
import { useDeleteEmitter } from '../../hooks/emitter'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
  /** The emitter's name, so the confirmation names what it is about to remove. */
  name?: string
  onSuccess?: () => void
}

const DeleteEmitterModal = ({
  id,
  interfaceId,
  name,
  onSuccess,
}: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const deleteModal = useDeleteEmitter()

  const handleDeleteEmitter = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    deleteModal(
      { interfaceId, id },
      {
        onSuccess: () => {
          onSuccess && onSuccess()
        },
      },
    )
  }, 300)

  return (
    <ConfirmModalUI
      title={t('DeleteEmitter')}
      name={name}
      text={t('emitterDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteEmitter}
    />
  )
}

export default DeleteEmitterModal
